import Vue from 'vue';
import OutputSection from './components/OutputSection.vue';
import AnimatedNumber from './components/AnimatedNumber.vue';
import Tooltip from './components/Tooltip.vue';

Vue.component('output-section', OutputSection);
Vue.component('animated-number', AnimatedNumber);
Vue.component('tooltip', Tooltip);
